import React from "react";
import clsx from "clsx";

import { withStyles } from '@material-ui/styles';
import { withRouter, Link } from 'react-router-dom';
import withCurrentUser from '../../../hocs/with_current_user.js.jsx';
import withShowToast from '../../../hocs/with_show_toast.js.jsx';
import { compose } from 'redux';

import HtmlContent from "../../../base/components/html_content.js.jsx";
import I18n from "../../../base/i18n.js.jsx";

import Button from "../../../base/buttons/button.js.jsx";

import BaseSessionPage from "./components/base_session_page.js.jsx";
import IlSentEmail from "./resources/illustrations/il_sent_email.js.jsx"

import Routes from "../../routes.js";

const styles = theme => ({
  button: {
    margin: "16px 0px",
    width: "100%",
  },
  comeBack: {
    marginBottom: "50px",
    ['@media (max-width: 768px)']: {
      marginBottom: "30px"
    }
  },
  text: {
    display: "block",
    fontSize: "20px",
    fontWeight: theme.typography.fontWeightLight,
    marginBottom: "30px",
    ['@media (max-width: 768px)']: {
      fontSize: "14px",
      marginTop: "-5px",
      marginBottom: "5px"
    }
  },
  illustration: {
    margin: "0 auto",
    width: "100%",
    height: "140px"
  }
});

class RegistrationPage extends React.Component {

  constructor(props) {
    super(props);
    this.onComeBack = this.onComeBack.bind(this);
  }

  onComeBack() {
    const { history } = this.props;
    if(history.length > 2) {
      history.goBack()
    }
    else {
      history.push(Routes.index())
    }
  }

  render() {
    return <BaseSessionPage>
      { this.registeredInfo() }
    </BaseSessionPage>
  }

  registeredInfo() {
    const { classes } = this.props;
    return <div className = { classes.comeBack }>
      <HtmlContent className = { classes.text } >
        { I18n.t("web.page.registration.text") }
      </HtmlContent>
      {/* <Button onClick = { this.onComeBack }
              className = { clsx(classes.button, classes.comeBack) } >
        { I18n.t("action.come_back") }
      </Button> */}
      <IlSentEmail className = { classes.illustration } />
    </div>
  }
}

export default compose(withRouter, withShowToast, withCurrentUser, withStyles(styles))(RegistrationPage)
